import { AdditionalHtsType } from '@xbcb/trade-data-types';
import { HtsObject } from 'types';

export const section232CopperInfoEffectiveDate = new Date('2026-07-30');

export const isSection232CopperSmeltAndCastApplicableForAnyTariff = (
  htsObjects: (HtsObject | undefined)[],
  estimatedImportDate: Date | undefined,
  // Hydra master bookings carry no import date (their Transportation tab is
  // hidden), so callers pass true to go by HTS alone.
  skipImportDateCheck = false,
): boolean =>
  htsObjects.some((tariff) =>
    Boolean(
      containsAdditionalHtsWithSection232CopperType(tariff) &&
        (skipImportDateCheck ||
          estimatedImportDateIsOnOrAfterEffectiveDate(estimatedImportDate)),
    ),
  );

const section232CopperTypes = new Set([
  AdditionalHtsType.SECTION_232_METAL,
  AdditionalHtsType.SECTION_232_METAL_EXCLUSION,
]);

const containsAdditionalHtsWithSection232CopperType = (
  hts?: HtsObject,
): boolean =>
  Boolean(
    hts?.additional?.some((additionalHts) =>
      section232CopperTypes.has(additionalHts?.type as AdditionalHtsType),
    ),
  );

const estimatedImportDateIsOnOrAfterEffectiveDate = (
  estimatedImportDate: Date | undefined,
): boolean =>
  Boolean(
    estimatedImportDate &&
      estimatedImportDate >= section232CopperInfoEffectiveDate,
  );
